import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import HTMLReactParser from 'html-react-parser'
import { returnCodeToBr } from 'lib/helper'
import { Spacer } from 'components/Utility'

type Props = {
  description: string
  headline: string
}

const PrintDeliveryOrderDescription: FC<Props> = (props) => {
  const { headline, description } = props
  return (
    <div>
      <h3 className={styles.printOrder__request__title}>{headline}</h3>
      <Spacer size={4} />
      <p className={styles.printOrder__request__content}>{HTMLReactParser(returnCodeToBr(description))}</p>
    </div>
  )
}

export default PrintDeliveryOrderDescription
